import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Grid, GridItem, Image, TextStyled } from '@nike/nike-design-system-components';
import Richtext from '../Richtext/Richtext';
import NotificationFooterButtons from './NotificationFooterButtons';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var NotificationContent = function NotificationContent(props) {
  var mediaHost = props.mediaHost,
    _props$isNotification = props.isNotification,
    isNotification = _props$isNotification === void 0 ? true : _props$isNotification,
    _props$isAuthor = props.isAuthor,
    isAuthor = _props$isAuthor === void 0 ? false : _props$isAuthor,
    _props$root = props.root,
    _props$root$image = _props$root.image,
    _props$root$image2 = _props$root$image === void 0 ? {} : _props$root$image,
    image = _props$root$image2.fileReference,
    text = _props$root.text,
    title = _props$root.title;
  return (
    /*#__PURE__*/
    // @ts-expect-error
    _jsxs(Grid, {
      rowGapXs: "12px",
      exteriorGapXs: "0px",
      children: [isAuthor ? /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: /*#__PURE__*/_jsx(TextStyled, {
          appearance: "display3",
          style: {
            font: 'var(--podium-cds-typography-320-to-1919-title3)'
          },
          role: "textbox",
          children: title
        })
      }) : /*#__PURE__*/_jsx("div", {}), image ? /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: /*#__PURE__*/_jsx(Image, {
          aspectRatio: "1/1",
          borderRadius: "none",
          image: {
            src: image.includes('http') ? image : "".concat(mediaHost).concat(image),
            alt: 'NIKE'
          }
        })
      }) : /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: /*#__PURE__*/_jsx(Richtext, {
          root: {
            text: text
          },
          isNotification: isNotification
        })
      }), isAuthor ? /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: /*#__PURE__*/_jsx(NotificationFooterButtons, _objectSpread({}, props))
      }) : /*#__PURE__*/_jsx("div", {})]
    })
  );
};